import { Branch, Company } from "../../../types/dataModels";
import { DataAPI_Base, GetAPI_Base } from "../base";

class GetAPI_Branches extends GetAPI_Base<Branch> {
	constructor() {
		super("branches");
	}

	public async byCompany(company: Company) {
		if (!company.branchIds || company.branchIds.length === 0) return [];
		const branches = await super.byIds(company.branchIds);
		return branches;
	}
}

export class BranchesAPI extends DataAPI_Base<Branch> {
	get: GetAPI_Branches;
	constructor() {
		super("branches");
		this.get = new GetAPI_Branches();
	}
}
